import React, { Component } from "react";
import { Row, Col } from "antd";
import Category from "../../components/CategoriesCard";
import ShippingCost from "../../components/ShpingCost";
import CatalogCard from "../../components/catalogCard";
import { Store } from "../../store";
import { connect } from "react-redux";
import { CatalogAction, UserAction } from "../../store/actions";

class Catalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
      },
      categoryName: "",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",
    };
  }

  componentDidMount() {
    const { getProducts, getCategories, getShippingCost, getUserDetails } = this.props;
    const userId = this.props.user?.[2].rmx_company_user?.id

    getCategories();
    getShippingCost();
    getUserDetails(userId)
  }

  componentDidUpdate(preProps, preState) {
    const { getProducts, getShipingCost, categories } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filters.category_id !== this.state.filters.category_id ||
      preState.filters.column !== this.state.filters.column ||
      preState.filters.per_page !== this.state.filters.per_page ||
      preState.filters.page !== this.state.filters.page
    ) {
      getProducts(this.state.filters, false);
    }
    if (preProps.shipingprice !== this.props.shipingprice) {
      this.setState({
        shipingprice: {
          am_charges: this.props?.shipingprice?.am_charges,
          pm_charges: this.props?.shipingprice?.pm_charges,
        },
      });
    }
    if (preProps.categories?.length !== categories?.length) {
      getProducts(
        { ...this.state.filters, category_id: categories?.[0]?.id },
        null
      )
      this.setState({
        categoryName: this.props.categories[0]?.name
      })
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };
  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };
  onChangeShowingFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        per_page: value,
      },
    });
  };

  onUpdateShippingCost = (e, type) => {
    if (e > 0 || e == 0) {
      this.setState({
        shipingprice: {
          ...this.state.shipingprice,
          [type]: e,
        },
      });
    }

  };

  onUpdatePrice = (updatedPrice) => {
    this.setState({
      price: updatedPrice,
    });
  };

  onChangeFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        column: value,
      },
    });
  };
  callOnCallBack = () => {
    this.props.getProducts(this.state.filters, false);
  };
  render() {
    return (
      <Row style={{ marginTop: '-10px' }}>
        <Col xl={6} lg={6} xs={24} sm={24} md={24} >
          <Category
            abc={this.abc}
            categorey={this.props.categories}
            categoryName={this.state.categoryName}
            {...this.props}
          />
          <ShippingCost
            onUpdateShippingCost={this.onUpdateShippingCost}
            updateShippingCost={this.props.updateShippingCost}
            value={this.state.shipingprice}
            shipingprice={this.props.shipingprice}
            postShippingCost={this.props.postShippingCost}
            isShippingCostLoading={this.props.isShippingCostLoading}
          />
        </Col>
        <Col xl={18} lg={18} xs={24} sm={24} md={24}>
          <CatalogCard
            {...this.props}
            categoryName={this.state.categoryName}
            onChangeFilter={this.onChangeFilter}
            onChangeShowingFilter={this.onChangeShowingFilter}
            metaData={this.props.metaData}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            updateProductPrice={this.props.updateProduct}
            onUpdateProductPrice={this.onUpdatePrice}
            value={this.state.price}
            onOpenModal={(e) => this.setState({ price: e })}
            callOnCallBack={this.callOnCallBack}
            dividerShow={true}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    products: store.CatalogReducer.products,
    metaData: store.CatalogReducer.metaData,
    categories: store.CatalogReducer.categories,
    shipingprice: store.CatalogReducer.shipingprice,
    isLoadingCategory: store.CatalogReducer.isLoadingCategorey,
    isLoading: store.CatalogReducer.isLodading,
    isShippingCostLoading: store.CatalogReducer.isShippingCostLoading,
    user: store.AuthReducer.user,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active, cb) =>
      dispatch(CatalogAction.updateProductReq(value, id, active, cb)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
    postShippingCost: (payload) =>
      dispatch(CatalogAction.postShippingCostReq(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Catalog);
